import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=2cc1aa30&scoped=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=2cc1aa30&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc1aa30",
  null
  
)

export default component.exports